import { DOCUMENT } from "@angular/common";
import { Inject, Injectable, Optional } from "@angular/core";

import { OBG_EVENT_BUS } from "../event-bus/event-bus.const";

import { ObgEventBus } from "./document.types";

@Injectable({
	providedIn: "root",
})
export class DocumentRef {
	// todo: https://github.com/angular/angular/issues/15640
	constructor(
		@Inject(DOCUMENT) private document: any,
		@Optional()
		@Inject(OBG_EVENT_BUS)
		private eventBus?: ObgEventBus
	) {}

	/**
	 * Document underlying native object
	 */
	get native(): Document {
		return this.document;
	}

	/**
	 * Get obgEventBus instance
	 */
	get obgEventBus(): ObgEventBus {
		return this.document.obgEventBus || this.eventBus;
	}
}
